import { render, staticRenderFns } from "./Prepared.vue?vue&type=template&id=32c963cc&scoped=true&"
import script from "./Prepared.vue?vue&type=script&lang=js&"
export * from "./Prepared.vue?vue&type=script&lang=js&"
import style0 from "./Prepared.vue?vue&type=style&index=0&id=32c963cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c963cc",
  null
  
)

export default component.exports